package com.iregained.site.components.sections.footer

import com.iregained.site.theme.toSitePalette
import com.iregained.site.utils.Res
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.s

// A clean, simple hover effect for footer links
val FooterLinkStyle = CssStyle {

    val palette = colorMode.toSitePalette()

    base {
        Modifier.color(palette.custom.darkText).transition(Transition.of("color", 0.2.s))
    }
    hover {
        Modifier.color(palette.brand.primary)
    }
}